import React from 'react';
import {
	Tab as MuiTab,
	type TabProps as MuiTabProps,
	Skeleton,
} from '@mui/material';

export interface TabProps extends MuiTabProps {
	loading?: boolean;
}

/**
 * Wrapper for `@mui/material/Tab`\
 * Currently just piping directly through to mui `Tab`\
 */
export const Tab = ({loading, ...props}: TabProps) => {
	return (
		<MuiTab
			{...props}
			label={loading ? <Skeleton variant="text" width={100} /> : props.label}
		/>
	);
};

export default Tab;
